// extracted by mini-css-extract-plugin
export var attachButton = "_cp-8";
export var sendButton = "_cp-2";
export var sendDisabled = "_cp-4";
export var sendEnabled = "_cp-3";
export var sendIcon = "_cp-6";
export var sendIconDisabled = "_cp-7";
export var sendStreaming = "_cp-5";
export var textarea = "_cp-1";
export var wrapper = "_cp-0";